import React from "react";
import axios from "axios";
import {MD5} from "./md5Hash.js";
import {isLocal} from "./devLiveCheck.js";

/* generateMarvelKey() is for the MD5() Hash required by Marvel. 
To keep the private key private, its stored in a php script on the live server. 
the else() here is just for local dev. it will be deleted before going live. 
And maybe before commits but probably not
*/

export function generateMarvelKey(){
    // if(!isLocal()){
    //     /*this will only work live bc of CORS issue*/
    //     axios.get("http://www.webnamehere.com/jarvis/key.php")
    //     .then(res => {
    //       var key = res.data;
    //       localStorage.setItem("marvelHash", key);
    //     }); 
    // }else{
        /*FOR LOCAL PURPOSES ONLY - HOPEFULLY YOU REMEMBER TO DELETE BEFORE AND COMMITS OF GO LIVE*/
        /*FUCK IT. THE PHP IS THROWING SOME CORS ERROR*/
        var privateKey = "29b3817cbc1445ec2bc704e980c45631d62cffe6";
        var publicKey = "3a7ee881bddc680e47706a7a2d04a326";
        var ts = 1;
        var combo = ts + privateKey + publicKey;
        var key = MD5(combo); 
        localStorage.setItem("marvelHash", key);
    //}
}



// WEBPACK FOOTER //
// ./src/components/includes/behindTheScenes/marvelKey.js